import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    Popconfirm,
    message,
} from 'antd';
const FormItem = Form.Item;
import { actions, asyncGet } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { formatFormData } from './utils';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
    }
    handleReset= () => {
        this.props.form.resetFields();
    }

    // 批量删除调用批量删除接口
    handleDeleteAll = async () => {
        const {transferData} = this.props;
        let {selectedRowKeys} = transferData;
        if (selectedRowKeys.length) {
            selectedRowKeys = JSON.stringify(selectedRowKeys);
            selectedRowKeys = JSON.parse(selectedRowKeys);
            selectedRowKeys = selectedRowKeys.map(item => {
                return {scriptId: item};
            });
            await this.props.delectAll(selectedRowKeys);
            this.props.asyncGet();
        } else {
            message.error('请先选中需要删除的元素');
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务监控</h2>
                {/* <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="脚本ID">
                                {getFieldDecorator('scriptId')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="脚本名称">
                                {getFieldDecorator('scriptName')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>

                        <Col span={6}>
                            <FormItem label="脚本类型" {...spans}>
                                {getFieldDecorator('scriptTye')(
                                    <Select allowClear placeholder="ALL" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value={'0'}>
                                            拉起
                                        </Option>
                                        <Option key='2' value={'1'}>
                                            下载
                                        </Option>
                                        <Option key='3' value={'2'}>
                                            安装
                                        </Option>
                                        <Option key='4' value={'3'}>
                                            其他
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="类型" {...spans}>
                                {getFieldDecorator('applySys')(
                                    <Select allowClear placeholder="ALL" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value={'android'}>
                                            android
                                        </Option>
                                        <Option key='2' value={'ios'}>
                                            ios
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button type="primary" onClick={() => {
                                this.props.editShow();
                            }} style={{ margin: '0 8px' }}>
                                添加
                            </Button>
                            <Popconfirm title="是否删除您选择的所有?" onConfirm={this.handleDeleteAll} >
                                <Button type="primary" style={{ margin: '0 8px' }}>
                                    < a href="#">批量删除</a>
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                </Form> */}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    transferData: state.scriptList.transferData,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));




// WEBPACK FOOTER //
// ./pages/monitor/name/search.js